import { render, staticRenderFns } from "./OrderSendModal.vue?vue&type=template&id=c01e57ec&"
import script from "./OrderSendModal.vue?vue&type=script&lang=js&"
export * from "./OrderSendModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports